<template>
    <div>
        <buttonlist @help="help" @search="search" @exps="exps" ref="SetBtn"></buttonlist>
        <div style="background: white;white-space: nowrap;overflow: auto">
            <el-button type="primary" size="mini" @click.native.prevent="add">{{$t('getapi[6467]')}}
            </el-button>
            <el-button type="primary" size="mini" @click.native.prevent="selectpart">{{$t('getapi[878]')}}
            </el-button>
            <el-button type="primary" size="mini" @click.native.prevent="selectsalpart">{{$t('getapi[878]')}}{{$t('getapi[447]')}}
            </el-button>
            <el-button type="primary" size="mini" @click.native.prevent="del">{{$t('getapi[7241]')}}</el-button>
        </div>
        <div style="display: flex">
            <div>
                <vxe-table
                        :data="dataDetail.ls"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="150"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        ref="ordertoexcel"
                        :auto-resize="true"
                >
                    <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                    
                    <vxe-table-column show-overflow-tooltip field="line" :title="$t('getapi[1425]')" sortable  width="65" ></vxe-table-column>
                    <vxe-table-column field="part_code" :title="$t('getapi[8222]')" width="200" sortable>
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.part_code" size="mini"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="qty" :title="$t('getapi[1562]')" width="200" sortable>
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.qty" size="mini" type="number"
                                      autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
            <div>
                <el-checkbox v-model="dataDetail.pur_flag" :true-label="1" :false-label="0">{{$t('getapi[8223]')}}</el-checkbox>
                <el-checkbox v-model="dataDetail.board_flag" :true-label="1" :false-label="0">{{$t('getapi[8224]')}}</el-checkbox>
                <el-checkbox v-model="dataDetail.mergepart_flag" :true-label="1" :false-label="0">{{$t('getapi[12616]')}}</el-checkbox>
            </div>
        </div>
        <el-tabs :tab-position="'top'" style="margin-top: 5px" v-model="activeName" @tab-click="selectInfo" >
            <el-tab-pane :label="$t('getapi[8225]')" name="0" id="xpane-0">
                <vxe-table :data="normalls"
                          :height="tableHeight"
                           :highlight-current-row="true"
                           border
                           size="mini"
                           resizable
                           :loading="loading"
                           show-overflow-tooltip="true"
                           :row-class-name="tableRowClassName1"
                          :header-cell-style="$limits.headerClass"
                           ref="singleTable">
                    <vxe-table-column field="part_code" :title="$t('getapi[2863]')" width="150px" sortable>
                         <template scope="scope">
                            <div v-if="scope.row.general_flag == 1" style="background: orange">
                                <span>{{scope.row.part_code}}</span>
                            </div>
                            <div v-if="scope.row.general_flag != 1 && scope.row.part_status==0" style="background: #ff7879">
                                <span>{{scope.row.part_code}}</span>
                            </div>
                             <div v-if="scope.row.general_flag != 1 && scope.row.part_status!=0">
                                 <span>{{scope.row.part_code}}</span>
                             </div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="part_engtype_name" :title="$t('getapi[118]')" sortable width="100px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="part_stuff" :title="$t('getapi[126]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="part_spec" :title="$t('getapi[125]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="part_model" :title="$t('getapi[124]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="page_no" :title="$t('getapi[133]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="part_name" :title="$t('getapi[2864]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column field="sum_amount" :title="$t('getapi[8228]')" sortable align="right" width="80px">
                        <template slot-scope="scope">
                            {{scope.row.sum_amount | thousandth}}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="unit_qty" :title="$t('getapi[6777]')" sortable align="right">
                        <template slot-scope="scope">
                            {{scope.row.unit_qty | thousandth}}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="top_item_code" :title="$t('getapi[13024]')" sortable width="100px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="top_part_code" :title="$t('getapi[8229]')" sortable width="100px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="mp_flag" :title="$t('getapi[2285]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="area" :title="$t('getapi[8421]')" sortable width="60px"></vxe-table-column>
                    <vxe-table-column field="routing_desc" :title="$t('getapi[143]')" sortable width="400px">
                        <template slot-scope="scope">
                            <span style="white-space:normal;">{{scope.row.routing_desc}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="routingremark" :title="$t('getapi[12391]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="direct_stuff_move_flag" :title="$t('getapi[553]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="move_direction" :title="$t('getapi[554]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="master_assist_rate" :title="$t('getapi[3599]')" sortable  align="right" width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="produce_leadtime" :title="$t('getapi[7215]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="on_hand" :title="$t('getapi[8230]')" sortable  align="right" width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="part_master_unit" :title="$t('getapi[4590]')" sortable width="80px"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="planning_code" :title="$t('getapi[736]')" sortable width="80px"></vxe-table-column>
                </vxe-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[8226]')" name="1" id="xpane-1">
                <el-table :data="childbomls"
                          :height="tableHeight"
                          header-row-class-name="headerclass"
                          border size="mini"
                          style="width: 100%; margin-top:0px"
                          :header-cell-style="$limits.headerClass">
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="p_part_code" :label="$t('getapi[8222]')" width="100"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[8227]')" name="2" id="xpane-2">
                <el-table :data="partls"
                          :height="tableHeight"
                          header-row-class-name="headerclass"
                          border size="mini"
                          style="width: 100%; margin-top:0px"
                          :header-cell-style="$limits.headerClass">
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="100"></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <!--选择物料-->
        <selector :isVisible="addpartvisible" :isBatch="true" :isSplitPage="true" :postUrl="'/Pro/SO/GetSOPartPopupDataList'"
                  @callback="getpart" ref="part"></selector>
        <!--选择销售件-->
        <selector :isVisible="false" :isBatch="true" :isSplitPage="true" :postUrl="'/Pro/SO/GetSalCoPartPopupDataList'"
                  @callback="getsalpart" ref="partsal"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_orderlisttoexcel',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight - 325
            }
        },
        data() {
            return {
                dataDetail: {
                    pur_flag: 0,
                    board_flag: 0,
                    mergepart_flag:0,
                    ls: [],
                    LangType:0,
                },
                activeName: 0,
                normalls: [],
                childbomls: [],
                partls: [],
                rowlineno:0,
                SelectIndex: '0',
                loading: false,
                addpartvisible: false,
                scrollTop:0,
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == '2_mrptranssrorder' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    let arr = data.List;
                    if(vm.rowlineno==0){
                        vm.rowlineno=1;
                    }
                    for(let i = 0;i<arr.length;i++){
                        vm.dataDetail.ls = [...vm.dataDetail.ls,{
                            line:vm.rowlineno++,
                            part_code: arr[i].part_code,
                        }]
                    }
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        watch: {
            normalls: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            childbomls: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            partls: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.authority();
        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8221]"),this.$t("getapi[25]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                //只读权
                that.$refs.SetBtn.SetButtonEnable('search,export');
            },
            search() {
                let that = this;
                for(let i = 0;i<that.dataDetail.ls.length;i++){
                    if(that.dataDetail.ls[i].part_code == ''){
                        that.$message.warning(that.$t('getapi[8829]'))//'下单总承号不能为空！'
                        return
                    }
                }
                that.loading = true
                that.dataDetail.LangType= that.$processdata.getLang();
                let parm = that.dataDetail
                that.$http.urlpost('/Pro/SO/GetSoAutoOrderList', parm, function (res) {
                    if (res.Success == 1) {
                        that.normalls = res.DataContent.normalls
                        that.childbomls = res.DataContent.childbomls
                        that.partls = res.DataContent.partls
                    }
                    that.loading = false
                });
            },
            add() {
                let that = this
                that.dataDetail.ls = [...that.dataDetail.ls, {
                    part_code: '',
                    qty: ''
                }]
            },
            del(){
                let that = this;
                let selectRecords = this.$refs.ordertoexcel.getCheckboxRecords();
                for(let i=selectRecords.length-1;i>=0;i--){
                    let line = this.$refs.ordertoexcel.getRowIndex(selectRecords[i]);
                    that.dataDetail.ls.splice(line, 1);
                }
            },
            selectInfo(tab){
                let that = this
                that.SelectIndex = tab.name
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            tableRowClassName1({row, rowIndex}){
                if(row.routing_desc.length>0){
                    if(row.routing_desc.includes('外协')){
                        return 'blue'
                    }
                }
            },
            exps(){
                let that = this;
                for(let i = 0;i<that.dataDetail.ls.length;i++){
                    if(that.dataDetail.ls[i].part_code == ''){
                        that.$message.warning(that.$t('getapi[8829]'))//'下单总承号不能为空！'
                        return
                    }
                }
                let parm = that.dataDetail
                parm.LangType=that.$processdata.getLang()
                parm.fromname= that.$t('getapi[11881]') + ';' +  that.$t('getapi[8226]') + ';' +that.$t('getapi[8227]')
                that.$http.urlpost('/Pro/SO/GetSoAutoOrderListToExcel', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 添加物料
            selectpart() {
                let that = this;
                that.addpartvisible = true
                that.$refs.part.clearInput(that.addpartvisible);
            },
            // 添加销售件
            selectsalpart() {
                let that = this;
                that.$refs.partsal.clearInput(true);
            },
            getpart(data) {
                let that = this;                
                if(that.rowlineno==0){
                    that.rowlineno=1;
                }
                for(let i = 0;i<data.length;i++){
                    that.dataDetail.ls = [...that.dataDetail.ls, {
                        line:that.rowlineno++,
                        part_code: data[i].part_code,
                        qty: ''
                    }]
                }
            },
            getsalpart(data) {
                let that = this;
                if(that.rowlineno==0){
                    that.rowlineno=1;
                }
                for(let i = 0;i<data.length;i++){
                    that.dataDetail.ls = [...that.dataDetail.ls, {
                        line:that.rowlineno++,
                        part_code: data[i].sales_part,
                        qty: data[i].sales_qty,
                    }]
                }
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if (this.$route.name == this.$options.name) {
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            check(datap) {
                let that = this
                console.log(JSON.stringify(datap))
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                if(that.rowlineno==0){
                    that.rowlineno=1;
                }
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 1) {
                        that.dataDetail.ls = [...that.dataDetail.ls, {
                            line:that.rowlineno++,
                            part_code: arr[i].split('\\t')[0],
                        }]
                    } else if(arr[i].split('\\t').length == 2){
                        that.dataDetail.ls = [...that.dataDetail.ls, {
                            line:that.rowlineno++,
                            part_code: arr[i].split('\\t')[0],
                            qty: arr[i].split('\\t')[1],
                        }]
                    }
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none;
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none;
    }

    .el-table .hidden-row {
        display: none;
    }
    /deep/.orange{
        background: orangered;
    }
    /deep/ .blue {
        background: #c7e160;
    }
</style>
